<template>
  <div class="travel-route-publish">
    <el-form
      :model="form"
      :rules="rules"
      ref="routeForm"
      label-width="110px"
      class="route-form"
    >
      <!-- 图片锦集 -->
      <div class="form-section">
        <el-form-item :label="$t('routeImageGallery')" prop="images">
          <div class="image-list">
            <div
              class="image-item"
              v-for="(file, index) in fileList"
              :key="index"
              @mouseenter="showActions = index"
              @mouseleave="showActions = -1"
            >
              <div class="image-wrapper">
                <div v-if="file.url === coverImage" class="cover-marker">
                  {{ $t("cover") }}
                </div>
                <el-image
                  ref="images"
                  style="width: 120px; height: 120px"
                  :src="file.url"
                  :preview-src-list="srcList"
                />
                <div v-if="showActions === index" class="image-actions">
                  <div class="delete">
                    <el-button
                      class="delete-btn"
                      circle
                      icon="el-icon-close"
                      @click="handleRemove(file)"
                    ></el-button>
                  </div>
                  <div class="preview">
                    <el-button
                      class="preview-btn"
                      circle
                      icon="el-icon-zoom-in"
                    ></el-button>
                  </div>
                  <div class="cover">
                    <el-button
                      v-if="file.url !== coverImage"
                      class="cover-btn"
                      size="mini"
                      @click="setCoverImage(file.url)"
                    >
                      {{ $t("setAsCover") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-upload
            class="image-upload"
            drag
            action="#"
            :auto-upload="false"
            :accept="'.jpg,.jpeg,.png'"
            :file-list="fileList"
            :on-change="(file, fileList) => handleFileSelect(file, fileList)"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :show-file-list="false"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              {{ $t("dragOrClickUpload") }}
            </div>
          </el-upload>
        </el-form-item>
      </div>

      <!-- 路线名称/行程天数 -->
      <div class="form-section row-layout">
        <div class="col">
          <el-form-item :label="$t('routeName')" prop="routeName">
            <el-input
              v-model="form.routeName"
              :placeholder="$t('pleaseEnterRouteName')"
            />
          </el-form-item>
        </div>
        <div class="col">
          <el-form-item :label="$t('tripDays')" prop="days">
            <el-input
              type="number"
              v-number-only
              v-model.number="form.days"
              :placeholder="$t('pleaseEnterTripDays')"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 出发地/目的地 -->
      <div class="form-section row-layout">
        <div class="col">
          <el-form-item :label="$t('departure')" prop="departure">
            <el-select
              v-model="form.departureId"
              :placeholder="$t('pleaseSelectOrSearchDeparture')"
              filterable
              clearable
              style="width: 100%"
              :loading="cityLoading"
              @change="(val) => handleCityChange(val, 'departure')"
            >
              <el-option
                v-for="city in cityOptions"
                :key="city.id"
                :label="
                  isEditMode
                    ? editMainLang === 'zh'
                      ? city.city
                      : editMainLang === 'ru'
                      ? city.city_ru
                      : city.city_en
                    : $i18n.locale === 'zh'
                    ? city.city
                    : city.city_en
                "
                :value="city.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="col">
          <el-form-item :label="$t('destination')" prop="destination">
            <el-select
              v-model="form.destinationId"
              :placeholder="$t('pleaseSelectOrSearchDestination')"
              filterable
              clearable
              style="width: 100%"
              :loading="cityLoading"
              @change="(val) => handleCityChange(val, 'destination')"
            >
              <el-option
                v-for="city in cityOptions"
                :key="city.id"
                :label="
                  isEditMode
                    ? editMainLang === 'zh'
                      ? city.city
                      : editMainLang === 'ru'
                      ? city.city_ru
                      : city.city_en
                    : $i18n.locale === 'zh'
                    ? city.city
                    : city.city_en
                "
                :value="city.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 成团人数 -->
      <div class="form-section row-layout">
        <div class="col">
          <el-form-item :label="$t('minGroupSize')" prop="minGroupSize">
            <el-input
              type="number"
              v-number-only
              v-model.number="form.minGroupSize"
              :placeholder="$t('pleaseEnterMinGroupSize')"
            />
          </el-form-item>
        </div>
        <div class="col">
          <el-form-item :label="$t('maxGroupSize')" prop="maxGroupSize">
            <el-input
              type="number"
              v-number-only
              v-model.number="form.maxGroupSize"
              :placeholder="$t('pleaseEnterMaxGroupSize')"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 标签/价格 -->
      <div class="form-section row-layout">
        <div class="col">
          <el-form-item :label="$t('productFeatures')" prop="features">
            <div class="tag-container">
              <el-tag
                v-for="(tag, index) in form.features"
                :key="index"
                closable
                @close="() => removeTag(index)"
              >
                {{ tag }}
              </el-tag>
              <el-input
                v-model="tagInput"
                class="tag-input"
                :placeholder="$t('enterTagPressEnter')"
                @keyup.enter.native="addTag"
              />
            </div>
          </el-form-item>
        </div>
        <div class="col">
          <el-form-item :label="$t('price')" prop="price">
            <el-input
              type="number"
              v-model.number="form.price"
              :placeholder="$t('pleaseEnterPrice')"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 行程方式 -->
      <div class="form-section row-layout">
        <div class="col">
          <el-form-item :label="$t('tripMode')" prop="travelTypeId">
            <el-select
              v-model="form.travelTypeId"
              @change="handleTravelTypeChange"
              :placeholder="$t('pleaseSelectTripMode')"
            >
              <el-option
                v-for="mode in travelTypeOptions"
                :key="mode.id"
                :value="mode.id"
                :label="
                  isEditMode
                    ? editMainLang === 'zh'
                      ? mode.name
                      : editMainLang === 'ru'
                      ? mode.name_ru
                      : mode.name_en
                    : $i18n.locale === 'zh'
                    ? mode.name
                    : mode.name_en
                "
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="col"></div>
      </div>

      <!-- 游玩主题 -->
      <el-form-item :label="$t('playTheme')" prop="themes">
        <div class="theme-container">
          <el-checkbox-group v-model="form.themeIds" @change="handleThemeCheck">
            <el-checkbox
              v-for="theme in themeOptions"
              :key="theme.id"
              :label="theme.id"
              class="theme-checkbox"
            >
              {{
                isEditMode
                  ? editMainLang === "zh"
                    ? theme.name
                    : editMainLang === "ru"
                    ? theme.name_ru
                    : theme.name_en
                  : $i18n.locale === "zh"
                  ? theme.name
                  : theme.name_en
              }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <!-- 简介 -->
      <div class="form-section">
        <el-form-item :label="$t('introduction')" prop="intro">
          <el-input
            v-model="form.intro"
            type="textarea"
            :placeholder="$t('pleaseEnterRouteIntro')"
          />
        </el-form-item>
      </div>

      <!-- 路线详情（富文本） -->
      <div class="form-section">
        <el-form-item :label="$t('routeDetail')" prop="details">
          <quill-editor
            v-model="form.details"
            ref="editor"
            :options="editorOption"
            @change="onEditorChange($event)"
          />
        </el-form-item>
      </div>

      <!-- 行程安排 -->
      <div class="form-section">
        <el-form-item :label="$t('tripSchedule')" prop="schedule">
          <TravelSchedule v-model="form.schedule" @change="validateSchedule" />
          <div v-if="scheduleError" class="el-form-item__error">
            {{ scheduleError }}
          </div>
        </el-form-item>
      </div>

      <!-- 费用说明 -->
      <div class="form-section">
        <el-form-item :label="$t('costDescription')" prop="costDesc">
          <el-input
            v-model="form.costDesc"
            type="textarea"
            :placeholder="$t('pleaseEnterCostDescription')"
          />
        </el-form-item>
      </div>

      <!-- 服务承诺 -->
      <div class="form-section">
        <el-form-item :label="$t('servicePromise')" prop="service_promises">
          <div class="promise-container">
            <el-checkbox-group
              v-model="form.servicePromiseIds"
              @change="handlePromiseCheck"
            >
              <el-checkbox
                v-for="promise in promiseOptions"
                :key="promise.id"
                :label="promise.id"
                class="promise-checkbox"
              >
                <!-- {{ $i18n.locale === "zh" ? promise.name : promise.name_en }} -->
                {{
                  isEditMode
                    ? editMainLang === "zh"
                      ? promise.name
                      : editMainLang === "ru"
                      ? promise.name_ru
                      : promise.name_en
                    : $i18n.locale === "zh"
                    ? promise.name
                    : promise.name_en
                }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </div>

      <!-- 预订须知 -->
      <div class="form-section">
        <el-form-item :label="$t('bookingNotice')" prop="bookingNotice">
          <el-input
            v-model="form.bookingNotice"
            type="textarea"
            :placeholder="$t('pleaseEnterBookingNotice')"
          />
        </el-form-item>
      </div>

      <!-- 操作按钮 -->
      <div class="form-section actions">
        <el-button type="primary" @click="handleSubmit">
          {{ $t("publishRoute") }}
        </el-button>
        <el-button @click="handleReset">
          {{ $t("reset") }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import TravelSchedule from "@/components/TravelSchedule.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "TravelRoutePublish",
  components: { quillEditor, TravelSchedule },
  data() {
    // 自定义验证：行程安排至少1天，每天至少1个景点
    // const validateSchedule = (rule, value, callback) => {
    //   if (!value || value.length === 0) {
    //     this.scheduleError = this.$t("pleaseAddAtLeastOneDayTrip");
    //     return callback(new Error(this.$t("pleaseAddAtLeastOneDayTrip")));
    //   }
    //   const hasValidDay = value.every((day) => {
    //     return (
    //       day.spots &&
    //       day.spots.length > 0 &&
    //       day.spots.some((spot) => spot.content.trim())
    //     );
    //   });
    //   if (!hasValidDay) {
    //     this.scheduleError = this.$t("eachDayMustHaveAtLeastOneSpot");
    //     return callback(new Error(this.$t("eachDayMustHaveAtLeastOneSpot")));
    //   }
    //   this.scheduleError = "";
    //   callback();
    // };
    // // 自定义验证：图片至少上传1张
    // const validateImages = (rule, value, callback) => {
    //   if (this.fileList.length === 0) {
    //     this.imageError = this.$t("pleaseUploadAtLeastOneImage");
    //     return callback(new Error(this.$t("pleaseUploadAtLeastOneImage")));
    //   }
    //   this.imageError = "";
    //   callback();
    // };
    return {
      isEditMode: false,
      routeId: "",
      form: {
        routeName: "", // 路线名称
        days: "", // 行程天数
        departure: "", // 出发地
        departureId: null, // 出发地ID
        departureEn: "",
        destinationId: null, // 目的地ID
        destination: "", // 目的地
        destinationEn: "",
        travelTypeId: "", // 行程方式
        travelTypeName: "", // 行程方式中文名称
        travelTypeNameEn: "", // 行程方式英文名称
        intro: "", // 简介
        features: [], // 产品特点
        price: "", // 价格
        details: "", // 路线详情
        schedule: [
          {
            spots: [
              {
                // 当天的景点列表
                time: "", // 景点时间
                content: "", // 景点内容
              },
            ],
          },
        ],
        costDesc: "", // 费用说明
        bookingNotice: "", // 预订须知
        images: [], // 用于图片验证的占位字段
        cover_image: "", // 用于存储封面图信息
        minGroupSize: "",
        maxGroupSize: "",
        themeIds: [], // 游玩主题选中ID

        themes: [],
        themesEn: [],
        servicePromiseIds: [], // 服务承诺选中ID

        service_promises: [], // 服务承诺
        servicePromisesEn: [],
      },
      // 验证规则：所有字段必填
      imageError: "",
      scheduleError: "",
      fileList: [],
      srcList: [],
      coverImage: "",
      tagInput: "",
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["link", "image"],
            ],
            handlers: {
              // 在这里配置图片上传处理器
              image: this.handleImageUpload,
            },
          },
        },
      },
      showActions: -1,
      isUploading: false,
      isUploadingImage: false, //富文本编辑器图片上传
      cityLoading: false,
      cityOptions: [],
      // 行程方式选项
      travelTypeOptions: [],
      themeOptions: [],
      promiseOptions: [],
      selectedThemeIds: [],
      // 编辑状态-路线主语言，发布状态无效
      editMainLang: "",
      regChinese: /[\u4e00-\u9fa5]/, // 包含中文字符
      // regNotChinese: /^[A-Za-z0-9\s\p{Punct}]+$/u, // 纯英文、数字、空格、标点
    };
  },
  computed: {
    // 👇 就这么写，必出红星，必切换中英文
    rules() {
      const _this = this; // 保存this指向
      // 这里放你的两个自定义校验
      const validateSchedule = (rule, value, callback) => {
        if (!value || value.length === 0) {
          this.scheduleError = this.$t("pleaseAddAtLeastOneDayTrip");
          return callback(new Error(this.$t("pleaseAddAtLeastOneDayTrip")));
        }
        const hasValidDay = value.every((day) => {
          return (
            day.spots &&
            day.spots.length > 0 &&
            day.spots.some((spot) => spot.content.trim())
          );
        });
        if (!hasValidDay) {
          this.scheduleError = this.$t("eachDayMustHaveAtLeastOneSpot");
          return callback(new Error(this.$t("eachDayMustHaveAtLeastOneSpot")));
        }
        this.scheduleError = "";
        callback();
      };

      const validateImages = (rule, value, callback) => {
        if (this.fileList.length === 0) {
          this.imageError = this.$t("pleaseUploadAtLeastOneImage");
          return callback(new Error(this.$t("pleaseUploadAtLeastOneImage")));
        }
        this.imageError = "";
        callback();
      };

      // 👇 这里返回完整规则
      return {
        routeName: [
          {
            required: true,
            message: this.$t("pleaseEnterRouteName"),
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              const locale = _this.$i18n.locale;
              const val = value || "";
              if (!val.trim()) return callback();
              if (locale === "zh") {
                if (/[A-Za-z]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTip")));
                }
              } else if (locale === "en") {
                if (/[\u4e00-\u9fa5]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTipEn")));
                }
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        days: [
          {
            required: true,
            message: this.$t("pleaseEnterTripDays"),
            trigger: "blur",
          },
          {
            type: "number",
            min: 1,
            message: this.$t("daysMustBeGreaterThanZero"),
            trigger: "blur",
          },
        ],
        departure: [
          {
            required: true,
            message: this.$t("pleaseEnterDeparture"),
            trigger: "change",
          },
        ],
        destination: [
          {
            required: true,
            message: this.$t("pleaseEnterDestination"),
            trigger: "change",
          },
        ],
        travelTypeId: [
          {
            required: true,
            message: this.$t("pleaseSelectTripMode"),
            trigger: "change",
          },
        ],
        minGroupSize: [
          {
            required: true,
            message: this.$t("pleaseEnterMinGroupSize"),
            trigger: "blur",
          },
          {
            type: "number",
            min: 1,
            message: this.$t("mustBeGreaterThanZero"),
            trigger: "blur",
          },
        ],
        maxGroupSize: [
          {
            required: true,
            message: this.$t("pleaseEnterMaxGroupSize"),
            trigger: "blur",
          },
          {
            type: "number",
            min: 1,
            message: this.$t("mustBeGreaterThanZero"),
            trigger: "blur",
          },
        ],
        intro: [
          {
            required: true,
            message: this.$t("pleaseEnterIntroduction"),
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              const locale = _this.$i18n.locale;
              const val = value || "";
              if (!val.trim()) return callback();

              if (locale === "zh") {
                if (/[A-Za-z]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTip")));
                }
              } else if (locale === "en") {
                if (/[\u4e00-\u9fa5]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTipEn")));
                }
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        themes: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.themes || this.form.themes.length === 0) {
                return callback(
                  new Error(this.$t("pleaseSelectAtLeastOneTheme")),
                );
              }
              callback();
            },
            trigger: "change",
          },
        ],
        service_promises: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                return callback(
                  new Error(this.$t("pleaseSelectAtLeastOneServicePromise")),
                );
              }
              callback();
            },
            trigger: "change",
          },
        ],
        features: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                return callback(
                  new Error(this.$t("pleaseAddAtLeastOneFeature")),
                );
              }
              callback();
            },
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: this.$t("pleaseEnterPrice"),
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: this.$t("priceMustBeGreaterThanZero"),
            trigger: "blur",
          },
        ],
        details: [
          {
            required: true,
            message: this.$t("pleaseEnterRouteDetail"),
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              const locale = _this.$i18n.locale;
              const val = value || "";
              if (!val.trim()) return callback();

              if (locale === "zh") {
                if (/[A-Za-z]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTip")));
                }
              } else if (locale === "en") {
                if (/[\u4e00-\u9fa5]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTipEn")));
                }
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        schedule: [
          { required: true, validator: validateSchedule, trigger: "change" },
        ],
        costDesc: [
          {
            required: true,
            message: this.$t("pleaseEnterCostDescription"),
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              const locale = _this.$i18n.locale;
              const val = value || "";
              if (!val.trim()) return callback();

              if (locale === "zh") {
                if (/[A-Za-z]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTip")));
                }
              } else if (locale === "en") {
                if (/[\u4e00-\u9fa5]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTipEn")));
                }
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        bookingNotice: [
          {
            required: true,
            message: this.$t("pleaseEnterBookingNotice"),
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              const locale = _this.$i18n.locale;
              const val = value || "";
              if (!val.trim()) return callback();

              if (locale === "zh") {
                if (/[A-Za-z]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTip")));
                }
              } else if (locale === "en") {
                if (/[\u4e00-\u9fa5]/.test(val)) {
                  return callback(new Error(_this.$t("langRuleTipEn")));
                }
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        images: [
          { required: true, validator: validateImages, trigger: "change" },
        ],
      };
    },
  },
  async created() {
    // 获取城市列表
    await this.getCityList();
    this.routeId = this.$route.query.id;
    if (this.routeId) {
      this.isEditMode = true;
      this.getEditData(); // 调用编辑回显接口
    } else {
      this.isEditMode = false;
      this.editMainLang = "";
      // 发布模式：初始化表单（如行程安排默认1天）
      this.form.schedule = [
        {
          spots: [
            {
              // 当天的景点列表
              time: "", // 景点时间
              content: "", // 景点内容
            },
          ],
        },
      ];
    }
    this.getStaticData();
  },
  mounted() {
    this.$nextTick(() => {
      // 确保编辑器已正确加载
      if (this.$refs.editor && this.$refs.editor.quill) {
        console.log("Quill编辑器初始化完成");
      }
    });
  },
  methods: {
    /**
     * 语种内容校验
     * @param {String} fieldName 字段名（用于多语言提示）
     * @param {String|Array} content 待校验内容
     * @returns {Boolean} true=校验通过 false=不通过
     */
    checkLangContent(content) {
      const locale = this.$i18n.locale;
      let text = "";

      // 处理数组类型（产品特点 features）
      if (Array.isArray(content)) {
        text = content.join("");
      } else {
        text = String(content || "");
      }

      // 空内容交给必填校验，这里直接放过
      if (!text.trim()) return true;

      // 中文环境：不允许包含英文字母
      if (locale === "zh") {
        if (/[A-Za-z]/.test(text)) {
          this.$message.warning(this.$t("langRuleTip"));
          return false;
        }
      }
      // 英文环境：不允许包含中文字符
      else if (locale === "en") {
        if (/[\u4e00-\u9fa5]/.test(text)) {
          this.$message.warning(this.$t("langRuleTipEn"));
          return false;
        }
      }

      return true;
    },

    handleCityChange(cityId, type) {
      // 找到选中的城市对象
      const selectedCity = this.cityOptions.find((city) => city.id === cityId);

      if (selectedCity) {
        // 根据类型（出发地/目的地）赋值
        if (type === "departure") {
          this.form.departure = selectedCity.city; // 出发地中文
          this.form.departureEn = selectedCity.city_en || ""; // 出发地英文
        } else if (type === "destination") {
          this.form.destination = selectedCity.city; // 目的地中文
          this.form.destinationEn = selectedCity.city_en || ""; // 目的地英文
        }
      } else {
        // 清空选择时重置
        if (type === "departure") {
          this.form.departure = "";
          this.form.departureEn = "";
        } else if (type === "destination") {
          this.form.destination = "";
          this.form.destinationEn = "";
        }
      }
    },

    // 行程方式选择事件：根据ID同步中英文名称
    handleTravelTypeChange(id) {
      // 找到选中的选项
      const selectedMode = this.travelTypeOptions.find(
        (mode) => mode.id === id,
      );
      if (selectedMode) {
        // 同步中英文名称到表单（供后端使用）
        this.form.travelTypeName = selectedMode.name; // 中文名称
        this.form.travelTypeNameEn = selectedMode.name_en || ""; // 英文名称
      } else {
        // 清空选择时重置
        this.form.travelTypeName = "";
        this.form.travelTypeNameEn = "";
      }
    },

    // 游玩主题选中事件：根据ID提取干净的双语文本数组
    handleThemeCheck() {
      // 1. 清空旧数据
      this.form.themes = [];
      this.form.themesEn = [];

      // 2. 过滤空ID
      const validIds = this.form.themeIds.filter(
        (id) => id !== null && id !== undefined,
      );
      if (validIds.length === 0) return;

      // 3. 根据ID匹配选项，提取双语文本
      validIds.forEach((id) => {
        const theme = this.themeOptions.find((item) => item.id === id);
        if (theme) {
          this.form.themes.push(theme.name); // 中文文本
          this.form.themesEn.push(theme.name_en || ""); // 英文文本
        }
      });
    },

    // 服务承诺选中事件：根据ID提取干净的双语文本数组
    handlePromiseCheck() {
      // 1. 清空旧数据
      this.form.service_promises = [];
      this.form.servicePromisesEn = [];

      // 2. 过滤空ID
      const validIds = this.form.servicePromiseIds.filter(
        (id) => id !== null && id !== undefined,
      );
      if (validIds.length === 0) return;

      // 3. 根据ID匹配选项，提取双语文本
      validIds.forEach((id) => {
        const promise = this.promiseOptions.find((item) => item.id === id);
        if (promise) {
          this.form.service_promises.push(promise.name); // 中文文本
          this.form.servicePromisesEn.push(promise.name_en || ""); // 英文文本
        }
      });
    },

    // 编辑回显接口
    getEditData2() {
      this.$get("/travel/travel_route_edit/get", { id: this.routeId })
        .then((res) => {
          if (res.data.code === 1) {
            const editData = res.data.data;
            // 填充表单数据（与回显接口返回格式对应）
            this.form = {
              id: editData.id, // 编辑提交需携带id
              routeName: editData.routeName,
              days: editData.days,
              departure: editData.departure,
              destination: editData.destination,
              travelTypeId: editData.travelTypeId,
              intro: editData.intro,
              features: editData.features,
              themes: editData.themes,
              service_promises: editData.service_promises,
              price: editData.price,
              minGroupSize: editData.minGroupSize,
              maxGroupSize: editData.maxGroupSize,
              details: editData.details,
              costDesc: editData.costDesc,
              bookingNotice: editData.bookingNotice,
              schedule: editData.schedule,
              images: editData.images,
              cover_image: editData.cover_image,
            };
            // 同步文件列表和封面图
            this.fileList = editData.images.map((url) => ({ url }));
            this.coverImage = editData.cover_image;
            this.srcList = editData.images;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log("加载编辑数据失败", err);
          this.$message.error(this.$t("loadEditDataFailed"));
        });
    },
    getEditData1() {
      this.$get("/travel/travel_route_edit/get", { id: this.routeId })
        .then((res) => {
          if (res.data.code === 1) {
            const editData = res.data.data;

            // 提前定义语种变量（复用）
            const lang = editData.language || "zh";

            // 新增：封装城市ID匹配函数（复用逻辑）
            const getCityId = (cityName) => {
              // 判断当前语种：zh用city，en用city_en
              return (
                this.cityOptions.find((city) => {
                  return lang === "en"
                    ? city.city_en === cityName
                    : city.city === cityName;
                })?.id || null
              );
            };

            // 处理 themes：区分 字符串/数组
            // let themesArr = [];
            // if (typeof editData.themes === "string" && editData.themes !== "") {
            //   themesArr = editData.themes.split(",");
            // } else if (Array.isArray(editData.themes)) {
            //   themesArr = editData.themes;
            // }

            // 处理 service_promises：区分 字符串/数组
            // let promiseArr = [];
            // if (
            //   typeof editData.service_promises === "string" &&
            //   editData.service_promises !== ""
            // ) {
            //   promiseArr = editData.service_promises.split(",");
            // } else if (Array.isArray(editData.service_promises)) {
            //   promiseArr = editData.service_promises;
            // }

            // 处理 themesEn
            // let themesEnArr = [];
            // if (
            //   typeof editData.themesEn === "string" &&
            //   editData.themesEn !== ""
            // ) {
            //   themesEnArr = editData.themesEn.split(",");
            // } else if (Array.isArray(editData.themesEn)) {
            //   themesEnArr = editData.themesEn;
            // }

            // 处理 servicePromisesEn
            // let servicePromisesEnArr = [];
            // if (
            //   typeof editData.servicePromisesEn === "string" &&
            //   editData.servicePromisesEn !== ""
            // ) {
            //   servicePromisesEnArr = editData.servicePromisesEn.split(",");
            // } else if (Array.isArray(editData.servicePromisesEn)) {
            //   servicePromisesEnArr = editData.servicePromisesEn;
            // }
            this.form = {
              id: editData.id, // 编辑提交需携带id
              routeName: editData.routeName,
              days: editData.days,
              departure:
                lang != "zh" ? editData.departure : editData.departure_lang_en,
              departureEn:
                lang != "zh" ? editData.departure_lang_en : editData.departure,
              destination:
                lang != "zh" ? editData.departure : editData.departure_lang_en,
              destinationEn: editData.departure_en,
              departureId: getCityId(editData.departure),
              destinationId: getCityId(editData.destination),
              travelTypeId: editData.travelTypeId,
              // travelTypeName : editData.travel_type_name,
              // travelTypeNameEn : editData.travel_type_name_en,
              intro: editData.intro,
              features: editData.features,
              price: editData.price,
              minGroupSize: editData.minGroupSize,
              maxGroupSize: editData.maxGroupSize,
              details: editData.details,
              costDesc: editData.costDesc,
              bookingNotice: editData.bookingNotice,
              schedule: editData.schedule,
              images: editData.images,
              cover_image: editData.cover_image,
              // 👉 主题回显：先拆分文本数组，再反查ID
              themes:
                editData.language != "zh"
                  ? editData.themes_lang_arr
                  : editData.themes,
              themesEn:
                editData.language != "zh"
                  ? editData.themes
                  : editData.themes_lang_arr,
              themeIds: editData.themes
                .map((text) => {
                  const trimText = text?.trim() || "";
                  return trimText
                    ? this.themeOptions.find((item) => {
                        return lang === "en"
                          ? item.name_en === trimText
                          : item.name === trimText;
                      })?.id
                    : null;
                })
                .filter((id) => id),
              // themes: editData.themes ? editData.themes.split(",") : [],
              // themeIds: editData.themes
              //   ? editData.themes
              //       .split(",")
              //       .map((text) => {
              //         const theme = this.themeOptions.find(
              //           (item) => item.name === text,
              //         );
              //         return theme ? theme.id : "";
              //       })
              //       .filter((id) => id)
              //   : [],
              // themesEn: editData.themesEn ? editData.themesEn.split(",") : [],

              // 👉 服务承诺回显：同理
              service_promises:
                lang != "zh"
                  ? editData.service_promises
                  : editData.service_promises_lang_arr,
              servicePromisesEn:
                lang != "zh"
                  ? editData.service_promises_lang_arr
                  : editData.service_promises,
              servicePromiseIds: editData.service_promises
                .map((text) => {
                  const trimText = text?.trim() || "";
                  return trimText
                    ? this.promiseOptions.find((item) => {
                        return lang === "en"
                          ? item.name_en === trimText
                          : item.name === trimText;
                      })?.id
                    : null;
                })
                .filter((id) => id),
              // servicePromiseIds: editData.service_promises
              //   ? editData.service_promises
              //       .split(",")
              //       .map((text) => {
              //         const promise = this.promiseOptions.find(
              //           (item) => item.name === text,
              //         );
              //         return promise ? promise.id : "";
              //       })
              //       .filter((id) => id)
              //   : [],
              // servicePromisesEn: editData.servicePromisesEn
              //   ? editData.servicePromisesEn.split(",")
              //   : [],
            };
            // 同步文件列表和封面图
            this.fileList = editData.images.map((url) => ({ url }));
            this.coverImage = editData.cover_image;
            this.srcList = editData.images;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log("加载编辑数据失败", err);
          this.$message.error(this.$t("loadEditDataFailed"));
        });
    },

    getEditData3() {
      this.$get("/travel/travel_route_edit/get", { id: this.routeId })
        .then((res) => {
          if (res.data.code === 1) {
            const editData = res.data.data;

            // 1. 核心：封装多语言字段读取函数（统一规则，避免硬编码）
            const getLangField = (
              baseField,
              lang = editData.language || "zh",
            ) => {
              // 中文直接读基础字段，其他语种读 基础字段_lang_语种，兜底基础字段
              const fieldKey =
                lang === "zh" ? baseField : `${baseField}_lang_${lang}`;
              return editData[fieldKey] ?? editData[baseField] ?? "";
            };

            // 2. 提前定义当前语种
            const currLang = editData.language || "zh";
            this.editMainLang = currLang;
            // 英文语种标识（用于反向读取英文字段）
            const enLang = "en";
            // 俄文语种标识（如需扩展，新增即可）
            // const ruLang = "ru";

            // 3. 封装城市ID匹配函数（适配多语言城市名）
            const getCityId = (cityName) => {
              if (!cityName) return null;
              return (
                this.cityOptions.find((city) => {
                  // 匹配规则：当前语种为en/ru时用对应字段，否则用中文city字段
                  return currLang === "en"
                    ? city.city_en === cityName
                    : currLang === "ru"
                    ? city.city_ru === cityName // 如需支持俄文，补充city_ru字段
                    : city.city === cityName;
                })?.id || null
              );
            };

            // 4. 封装主题ID匹配函数（适配多语言主题名）
            const getThemeId = (themeText) => {
              if (!themeText) return null;
              const trimText = themeText.trim();
              return (
                this.themeOptions.find((item) => {
                  return currLang === "en"
                    ? item.name_en === trimText
                    : currLang === "ru"
                    ? item.name_ru === trimText // 如需支持俄文，补充name_ru字段
                    : item.name === trimText;
                })?.id || null
              );
            };

            // 5. 封装服务承诺ID匹配函数（适配多语言）
            const getPromiseId = (promiseText) => {
              if (!promiseText) return null;
              const trimText = promiseText.trim();
              return (
                this.promiseOptions.find((item) => {
                  return currLang === "en"
                    ? item.name_en === trimText
                    : currLang === "ru"
                    ? item.name_ru === trimText // 如需支持俄文，补充name_ru字段
                    : item.name === trimText;
                })?.id || null
              );
            };

            // 6. 读取多语言字段（核心：根据当前语种动态读取）
            // 出发地/目的地
            const departure = getLangField("departure", currLang);
            const departureEn = getLangField("departure", enLang);
            const destination = getLangField("destination", currLang);
            const destinationEn = getLangField("destination", enLang);
            // 主题/服务承诺（数组格式，后端已转数组）
            const themes = getLangField("themes", currLang) || [];
            const themesEn = getLangField("themes", enLang) || [];
            const servicePromises =
              getLangField("service_promises", currLang) || [];
            const servicePromisesEn =
              getLangField("service_promises", enLang) || [];
            // 其他多语言文本
            const routeName = getLangField("route_name", currLang);
            const intro = getLangField("intro", currLang);
            const details = getLangField("details", currLang);
            const costDesc = getLangField("cost_desc", currLang);
            const bookingNotice = getLangField("booking_notice", currLang);
            const schedule = getLangField("schedule", currLang) || [];

            // 7. 组装表单数据
            this.form = {
              id: editData.id, // 编辑提交需携带id
              // 基础字段（多语言适配）
              routeName: routeName,
              days: editData.days,
              // 出发地/目的地（当前语种 + 英文）
              departure: departure,
              departureEn: departureEn,
              destination: destination,
              destinationEn: destinationEn,
              // 城市ID（根据当前语种的城市名匹配）
              departureId: getCityId(departure),
              destinationId: getCityId(destination),
              // 其他基础字段
              travelTypeId: editData.travelTypeId,
              intro: intro,
              features: getLangField("features", currLang) || [],
              price: editData.price,
              minGroupSize: editData.minGroupSize,
              maxGroupSize: editData.maxGroupSize,
              details: details,
              costDesc: costDesc,
              bookingNotice: bookingNotice,
              schedule: schedule,
              images: editData.images || [],
              cover_image: editData.cover_image || "",
              // 主题（当前语种 + 英文）+ 主题ID
              themes: themes,
              themesEn: themesEn,
              themeIds: themes
                .map((themeText) => getThemeId(themeText))
                .filter((id) => id),
              // 服务承诺（当前语种 + 英文）+ 服务承诺ID
              service_promises: servicePromises,
              servicePromisesEn: servicePromisesEn,
              servicePromiseIds: servicePromises
                .map((promiseText) => getPromiseId(promiseText))
                .filter((id) => id),
            };

            // 8. 同步文件列表和封面图
            this.fileList = (editData.images || []).map((url) => ({ url }));
            this.coverImage = editData.cover_image || "";
            this.srcList = editData.images || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log("加载编辑数据失败", err);
          this.$message.error(this.$t("loadEditDataFailed"));
        });
    },

    getEditData() {
      this.$get("/travel/travel_route_edit/get", { id: this.routeId })
        .then((res) => {
          if (res.data.code === 1) {
            const editData = res.data.data;

            // 1. 核心：固定字段读取函数（完全匹配后端返回格式）
            // 中文基础字段：直接读 departure/destination 等
            // 英文字段：固定读 字段名_lang_en（如 departure_lang_en）
            const getZhField = (baseField) => editData[baseField] ?? "";
            const getEnField = (baseField) =>
              editData[`${baseField}_lang_en`] ?? "";

            // 2. 仅保留当前语种标识（用于下拉选项ID匹配）
            const currLang = editData.language || "zh";
            this.editMainLang = currLang;

            // 3. 封装城市ID匹配函数（适配多语言城市名）
            const getCityId = (cityName) => {
              if (!cityName) return null;
              return (
                this.cityOptions.find((city) => {
                  // 匹配规则：根据当前语种匹配对应城市名
                  return currLang === "en"
                    ? city.city_en === cityName
                    : currLang === "ru"
                    ? city.city_ru === cityName
                    : city.city === cityName;
                })?.id || null
              );
            };

            // 4. 封装主题ID匹配函数（适配多语言主题名）
            const getThemeId = (themeText) => {
              if (!themeText) return null;
              const trimText = themeText.trim();
              return (
                this.themeOptions.find((item) => {
                  return currLang === "en"
                    ? item.name_en === trimText
                    : currLang === "ru"
                    ? item.name_ru === trimText
                    : item.name === trimText;
                })?.id || null
              );
            };

            // 5. 封装服务承诺ID匹配函数（适配多语言）
            const getPromiseId = (promiseText) => {
              if (!promiseText) return null;
              const trimText = promiseText.trim();
              return (
                this.promiseOptions.find((item) => {
                  return currLang === "en"
                    ? item.name_en === trimText
                    : currLang === "ru"
                    ? item.name_ru === trimText
                    : item.name === trimText;
                })?.id || null
              );
            };

            // 6. 读取字段（严格匹配后端返回）
            // 中文基础字段
            const departureZh = getZhField("departure"); // 上海
            const destinationZh = getZhField("destination"); // 南京
            const themesZh = getZhField("themes") || []; // ["摄影", "冲浪"]
            const servicePromisesZh = getZhField("service_promises") || []; // ["认证商家", "铁定成团"]
            const featuresZh = getZhField("features") || []; // ["包括早餐"]
            // 英文字段（_lang_en 后缀）
            const departureEn = getEnField("departure"); // Shanghai
            const destinationEn = getEnField("destination"); // NanJing
            const themesEn = getEnField("themes") || []; // ["Photography", "Surfing"]
            const servicePromisesEn = getEnField("service_promises") || []; // ["Certified Merchant", "Guaranteed Group Departure"]
            const featuresEn = getEnField("features") || []; // ["Including breakfast"]
            // 其他文本字段（中文基础字段）
            const routeName = getZhField("route_name");
            const intro = getZhField("intro");
            const details = getZhField("details");
            const costDesc = getZhField("cost_desc");
            const bookingNotice = getZhField("booking_notice");
            const schedule = getZhField("schedule") || [];

            // 7. 组装表单数据（区分中文/英文字段）
            this.form = {
              id: editData.id, // 编辑ID
              // 基础字段
              routeName: routeName,
              days: editData.days,
              price: editData.price,
              minGroupSize: editData.minGroupSize || editData.min_group_size, // 兼容两种字段名
              maxGroupSize: editData.maxGroupSize || editData.max_group_size,
              travelTypeId: editData.travelTypeId || editData.travel_type_id,
              // 出发地/目的地（中文+英文）
              departure: departureZh, // 中文：上海
              departureEn: departureEn, // 英文：Shanghai
              destination: destinationZh, // 中文：南京
              destinationEn: destinationEn, // 英文：NanJing
              // 城市ID（根据当前语种匹配：主语种是en则用英文城市名匹配）
              departureId: getCityId(
                currLang === "en" ? departureEn : departureZh,
              ),
              destinationId: getCityId(
                currLang === "en" ? destinationEn : destinationZh,
              ),
              // 特色/主题/服务承诺（中文+英文）
              features: featuresZh,
              featuresEn: featuresEn,
              themes: themesZh,
              themesEn: themesEn,
              service_promises: servicePromisesZh,
              servicePromisesEn: servicePromisesEn,
              // 富文本/文本字段
              intro: intro,
              details: details,
              costDesc: costDesc,
              bookingNotice: bookingNotice,
              schedule: schedule,
              // 图片相关
              images: editData.images || [],
              cover_image: editData.cover_image || "",
              // ID匹配（根据当前语种：en用英文主题/承诺名匹配ID）
              themeIds: (currLang === "en" ? themesEn : themesZh)
                .map((text) => getThemeId(text))
                .filter((id) => id),
              servicePromiseIds: (currLang === "en"
                ? servicePromisesEn
                : servicePromisesZh
              )
                .map((text) => getPromiseId(text))
                .filter((id) => id),
            };

            // 8. 同步文件列表和封面图
            this.fileList = (editData.images || []).map((url) => ({ url }));
            this.coverImage = editData.cover_image || "";
            this.srcList = editData.images || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log("加载编辑数据失败", err);
          this.$message.error(this.$t("loadEditDataFailed"));
        });
    },

    //获取静态数据
    getStaticData() {
      this.$get("/get_static", {
        type: "travel_modes,promise_options,theme_options",
      }).then((res) => {
        if (res.data.code === 1) {
          this.travelTypeOptions = res.data.data.travel_modes;
          this.promiseOptions = res.data.data.promise_options;
          this.themeOptions = res.data.data.theme_options;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取城市列表接口
    async getCityList() {
      this.cityLoading = true;
      await this.$get("/tourist_city")
        .then((res) => {
          this.cityLoading = false;
          if (res.data.code === 1) {
            this.cityOptions = res.data.data || [];
          } else {
            this.$message.error(this.$t("getCityListFailed") + res.msg);
            this.cityOptions = [
              { id: 1, city: "北京市" },
              { id: 2, city: "上海市" },
              { id: 3, city: "广州市" },
            ];
          }
        })
        .catch((err) => {
          this.cityLoading = false;
          console.log("获取城市列表异常", err);
          this.$message.error(this.$t("getCityListErrorPleaseRetry"));
        });
    },
    // 上传逻辑（同之前）
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error(this.$t("onlyImagesCanBeUploaded"));
        return false;
      }
      return true;
    },
    handleFileSelect(file, fileList) {
      file.url = URL.createObjectURL(file.raw);
      this.fileList = fileList;
      this.srcList = this.fileList.map((item) => item.url);
      // 自动设置封面
      if (!this.coverImage && this.fileList.length > 0) {
        this.coverImage = this.fileList[0].url;
        this.form.cover_image = this.coverImage;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      this.srcList = this.fileList.map((item) => item.url);
      if (file.url === this.coverImage) {
        this.coverImage = this.fileList.length > 0 ? this.fileList[0].url : "";
        this.form.cover_image =
          this.fileList.length > 0 ? this.fileList[0].url : "";
      }
      if (file.url && file.url.startsWith("blob:")) {
        URL.revokeObjectURL(file.url);
      }
    },
    handleThemeChange() {
      // 将选中的主题ID转换为对应的名称
      const selectedThemes = this.themeOptions
        .filter((theme) => this.selectedThemeIds.includes(theme.id))
        .map((theme) => theme.name);
      // 直接更新表单数据
      this.form.themes = selectedThemes;
    },
    // 滚动到第一个错误的表单项
    scrollToFirstError() {
      const errorEl = document.querySelector(".el-form-item.is-error");
      if (errorEl) {
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    validateSchedule() {
      this.$refs.routeForm.validateField("schedule");
    },
    // 标签逻辑
    addTag() {
      if (this.tagInput.trim()) {
        this.form.features.push(this.tagInput.trim());
        this.tagInput = "";
      }
    },
    removeTag(index) {
      this.form.features.splice(index, 1);
    },
    // 富文本逻辑
    onEditorChange({ html }) {
      this.form.details = html;
    },
    handleReset() {
      this.$refs.routeForm.resetFields();
      this.fileList = [];
      this.coverImage = "";
      this.tagInput = "";
      this.form.schedule = [{ spots: [{ content: "" }] }]; // 重置行程
      this.imageError = "";
      this.scheduleError = "";
      this.editMainLang = "";
      this.$message.info(this.$t("formReset"));
    },
    // // 提交表单
    // async handleSubmit() {
    //   // 检查是否正在上传
    //   if (this.isUploading) {
    //     this.$message.warning(this.$t("uploadingPleaseWait"));
    //     return;
    //   }
    //   this.publishLoading = true;
    //   this.$refs.routeForm.validate(async (valid) => {
    //     if (valid) {
    //       // 验证通过，执行提交逻辑
    //       const allFiles = this.fileList;
    //       // 过滤出需要上传的文件（有 raw 属性的文件）
    //       const newFilesToUpload = allFiles.filter((file) => file.raw);
    //       // 显示上传中提示
    //       this.isUploading = true;
    //       const loading = this.$loading({
    //         lock: true,
    //         text: this.$t("uploadingFile"),
    //         spinner: "el-icon-loading",
    //         background: "rgba(0, 0, 0, 0.7)",
    //       });
    //       try {
    //         // 无论是否有新图，都执行上传逻辑（无新图时直接 resolve）
    //         await this.uploadFiles(newFilesToUpload);
    //         this.submitForm();
    //       } catch (error) {
    //         console.error("文件上传失败:", error);
    //       } finally {
    //         this.isUploading = false;
    //         loading.close();
    //         this.publishLoading = false;
    //       }
    //     } else {
    //       // 验证失败，滚动到第一个错误位置
    //       this.scrollToFirstError();
    //       this.publishLoading = false;
    //       return false;
    //     }
    //   });
    // },

    async handleSubmit() {
      // 防重复提交
      if (this.publishLoading) return;
      this.publishLoading = true;

      // ✅ 开启全局遮罩 loading（唯一的 loading）
      const loading = this.$loading({
        lock: true,
        text: this.$t("uploadingFile"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        // 1. 表单校验
        const valid = await this.$refs.routeForm.validate().catch(() => false);
        if (!valid) {
          this.scrollToFirstError();
          return;
        }

        // ========== 新增：语种强制校验 开始 ==========
        // 需要校验的字段映射：[表单字段, 翻译Key]
        const checkList = [
          { key: "routeName", label: "routeName" }, // 路线名称
          { key: "features", label: "productFeatures" }, // 产品特点
          { key: "intro", label: "introduction" }, // 简介
          { key: "details", label: "routeDetail" }, // 路线详情
          { key: "costDesc", label: "costDescription" }, // 费用说明
          { key: "bookingNotice", label: "bookingNotice" }, // 预订须知
        ];

        // 逐个校验文本类字段
        for (const item of checkList) {
          const pass = this.checkLangContent(this.form[item.key]);
          if (!pass) {
            return; // 校验失败直接终止提交
          }
        }

        // 单独校验 行程安排 schedule（数组嵌套结构）
        const scheduleText = this.form.schedule
          .map((day) => day.spots.map((spot) => spot.content).join(""))
          .join("");
        const schedulePass = this.checkLangContent(scheduleText);
        if (!schedulePass) {
          return;
        }
        // ========== 新增：语种强制校验 结束 ==========

        // 2. 上传文件（等待完成）
        const allFiles = this.fileList;
        const newFiles = allFiles.filter((file) => file.raw);
        if (newFiles.length > 0) {
          this.isUploading = true;
          await this.uploadFiles(newFiles);
          this.isUploading = false;
        }

        // 3. ✨ 等待后端接口完全响应（必须等待）
        await this.submitForm();
      } catch (err) {
        console.error("提交失败：", err);
      } finally {
        // ✅ ✅ ✅ 重点：上传 + 接口全部结束后才关闭
        loading.close();
        this.publishLoading = false;
      }
    },

    /**
     * 上传多个文件到服务器（仅处理新图，已在调用前筛选）
     * @param {Array<File>} newFiles - 仅包含需要上传的新图（含 raw 文件对象）
     * @returns {Promise} - 上传结果的Promise
     */
    uploadFiles(newFiles) {
      return new Promise((resolve, reject) => {
        // 1. 没有新图需要上传时，直接复用旧图地址
        if (newFiles.length === 0) {
          // 合并所有图片地址（旧图 + 可能存在的未上传新图）
          this.form.images = this.fileList.map((file) => file.url);
          this.form.cover_image = this.coverImage;
          resolve({ data: { code: 1 } });
          return;
        }
        // 2. 有新图需要上传，创建表单数据
        const formData = new FormData();
        newFiles.forEach((file, index) => {
          // 标记封面索引（基于新图列表的索引）
          if (file.url === this.coverImage) {
            formData.append("coverIndex", index);
          }
          formData.append(`files[]`, file.raw);
        });
        // 3. 发送上传请求
        this.$post("/travel_file_upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then((res) => {
            if (res.data.code === 1) {
              // 合并旧图地址 + 新图地址
              const oldImageUrls = this.fileList
                .filter((file) => !file.raw) // 旧图：无 raw 属性
                .map((file) => file.url);
              const newImageUrls = res.data.data.imageUrls;
              this.form.images = [...oldImageUrls, ...newImageUrls];
              this.form.cover_image =
                res.data.data.coverImageUrl || this.coverImage;
              // 更新 fileList：清空新图的 raw 属性（避免重复上传）
              this.fileList = this.fileList.map((file) => {
                if (file.raw) {
                  return { ...file, raw: null }; // 新图上传后清除 raw
                }
                return file; // 旧图保持不变
              });
              resolve(res);
            } else {
              this.$message.error(res.data.msg || this.$t("uploadFailed"));
              reject(new Error(res.data.msg || this.$t("uploadFailed")));
            }
          })
          .catch((error) => {
            console.error("上传文件出错:", error);
            this.$message.error(this.$t("uploadErrorPleaseRetry"));
            reject(error);
          });
      });
    },
    /**
     * 富文本编辑器图片上传到OSS
     * @param file
     */
    async uploadImageToOSS(file) {
      try {
        this.isUploadingImage = true; // 开始上传，设置状态
        // 创建表单数据
        const formData = new FormData();
        formData.append("file", file);
        // 发送上传请求
        const res = await this.$post("/rich_file_upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // 检查响应状态
        if (res.data.code === 1 && res.data.data.fileUrl) {
          return res.data.data.fileUrl; // 返回URL供编辑器使用
        } else {
          throw new Error(res.data.msg || this.$t("imageUploadFailed"));
        }
      } catch (error) {
        console.log("图片上传失败:", error.message);
        this.$message.error(this.$t("imageUploadFailedPleaseRetry"));
        return Promise.reject(error);
      } finally {
        this.isUploadingImage = false; // 无论成功失败，都结束上传状态
      }
    },
    /**
     * 处理图片上传并插入到编辑器
     */
    handleImageUpload() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          try {
            // 调用OSS上传方法
            const imageUrl = await this.uploadImageToOSS(file);
            // 获取当前编辑器光标位置
            const quill = this.$refs.editor.quill;
            const range = quill.getSelection();
            // 在光标位置插入图片
            quill.insertEmbed(range.index, "image", imageUrl);
            quill.setSelection(range.index + 1);
          } catch (error) {
            console.error("插入图片失败:", error);
            this.$message.error(this.$t("insertImageFailedPleaseRetry"));
          }
        }
      };
      // 触发文件选择
      input.click();
    },
    editSubmitForm() {
      const submitData = {
        ...this.form,
        // 将数组字段转换为JSON字符串，符合后端要求
        features: JSON.stringify(this.form.features),
        themes: JSON.stringify(this.form.themes),
        service_promises: JSON.stringify(this.form.service_promises),
        schedule: JSON.stringify(this.form.schedule),
      };
      // 编辑模式：调用编辑提交接口
      this.$post("/travel/travel_route_edit/submit", submitData).then((res) => {
        if (res.data.code === 1) {
          this.$message.success(res.data.msg);
          this.$router.push("/travel/route-list");
        } else {
          this.$message.error(res.data.msg || this.$t("editFailedPleaseRetry"));
        }
      });
    },
    async submitForm() {
      const submitData = {
        ...this.form,
        features: JSON.stringify(this.form.features),
        themes: JSON.stringify(this.form.themes),
        themesEn: JSON.stringify(this.form.themesEn),
        service_promises: JSON.stringify(this.form.service_promises),
        servicePromisesEn: JSON.stringify(this.form.servicePromisesEn),
        schedule: JSON.stringify(this.form.schedule),
      };
      const apiUrl = this.isEditMode
        ? "/travel/travel_route_edit/submit" // 编辑接口
        : "/travel/travel_route_publish"; // 发布接口
      this.$post(apiUrl, submitData)
        .then((res) => {
          if (res.data.code === 1) {
            // 成功提示（区分编辑/发布文案）
            const successMsg = this.isEditMode
              ? this.$t("editSuccess")
              : this.$t("publishSuccess");
            this.$message.success(res.data.msg || successMsg);
            this.$router.push("/travel/route-list");
          } else {
            const errorMsg = this.isEditMode
              ? this.$t("editFailedPleaseRetry")
              : this.$t("publishFailedPleaseRetry");
            this.$message.error(res.data.msg || errorMsg);
          }
        })
        .catch((error) => {
          console.error(`${this.isEditMode ? "编辑" : "发布"}请求失败:`, error);
          this.$message.error(this.$t("networkErrorOperationFailed"));
        });
      // .finally(() => {
      //   // 🔔 无论成功/失败，最终都关闭发布加载状态（兜底）
      //   this.publishLoading = false;
      // });
    },
    setCoverImage(url) {
      this.coverImage = url;
      this.form.cover_image = url;
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-top: 20px;
}
.travel-route-publish {
  padding: 40px;
  background: #f9fafb;
  border-radius: 10px;
}
::v-deep .el-form {
  background: #ffffff;
  padding: 40px;
  margin: auto;
  width: 80%;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 8px;
  display: block;
}
::v-deep .el-form-item__label {
  text-align: left !important;
  padding-right: 15px !important;
}
::v-deep .el-upload,
::v-deep .el-upload-dragger {
  width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 32px;
}
.image-validation ::v-deep .el-form-item__error {
  position: relative;
  top: 0;
  left: 0;
  margin: 8px 0px;
}
::v-deep .el-form-item__error {
  margin: 8px 0px;
}
::v-deep .el-tag {
  margin-right: 5px;
}
.form-section.actions {
  display: flex;
  justify-content: center;
}
.image-upload {
  margin-bottom: 0 !important;
}
.cover-marker {
  height: 26px;
  line-height: 26px;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #e74c3c;
  color: white;
  font-size: 12px;
  padding: 0px 10px;
  border-bottom-right-radius: 6px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.tag-input {
  flex: 1;
  min-width: 120px;
}
.schedule-day {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}
.day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.schedule-spot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.spot-input {
  flex: 1;
}
.add-day-btn {
  width: 100%;
  text-align: center;
}
.ql-container {
  min-height: 200px;
  border-radius: 4px;
  border: 1px solid #dcdfe6 !important;
}
::v-deep .ql-toolbar {
  font-size: 18px;
  line-height: 1.5;
}
.ql-toolbar {
  border-radius: 4px 4px 0 0;
  border: 1px solid #dcdfe6 !important;
  background-color: #fafafa;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}
.image-item {
  position: relative;
  width: 120px;
  height: 120px;
}
.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.image-item:hover {
  transform: scale(1.05);
}
.image-actions {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
}
.image-item:hover .image-actions {
  opacity: 1;
}
.image-actions .preview,
.image-actions .cover {
  display: flex;
  justify-content: center;
}
.image-actions .cover {
  pointer-events: auto;
}
.preview-btn {
  border: none;
  background: none;
  color: #fff;
  font-size: 20px;
}
.delete-btn {
  position: absolute;
  right: 0;
  padding: 5px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border: none;
  pointer-events: auto;
}
.cover-btn:has(span:contains("已设为封面")):hover {
  background-color: rgba(25, 135, 84, 0.9);
}
.image-upload {
  margin-bottom: 16px;
}
.image-upload:hover {
  border-color: #409eff;
}
.row-layout {
  display: flex;
  gap: 20px;
}
.col {
  flex: 1;
}
@media (max-width: 768px) {
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
    margin-top: 50px;
  }
  .travel-route-publish {
    padding: 12px;
  }
  .ql-container {
    min-height: 150px;
  }
  .row-layout {
    flex-direction: column;
    gap: 0;
  }
}
</style>
